import { Card, Form, Select, InputNumber, Button, message } from 'antd';
import { useEffect, useState } from 'react';
import api from '../utils/api';
import type { SystemSettings } from '../types';

export default function Settings() {
  const [, setSettings] = useState<SystemSettings | null>(null);
  const [form] = Form.useForm();

  useEffect(() => {
    api.get('settings').json<{ success: boolean; data: SystemSettings }>().then((res) => {
      if (res.success && res.data) {
        setSettings(res.data);
        form.setFieldsValue(res.data);
      }
    });
  }, []);

  const handleSave = async (values: SystemSettings) => {
    try {
      await api.put('settings', { json: values });
      message.success('设置已保存');
    } catch (error) {
      message.error('保存失败');
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>系统设置</h2>
      <Card title="缓存配置" style={{ marginBottom: 24 }}>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name={['cache', 'type']} label="缓存类型" rules={[{ required: true }]}>
            <Select options={[
              { value: 'memory', label: '内存缓存' },
              { value: 'redis', label: 'Redis 缓存' },
            ]} />
          </Form.Item>
          <Form.Item name={['cache', 'maxSize']} label="最大缓存条目数" rules={[{ required: true }]}>
            <InputNumber min={100} max={100000} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name={['cache', 'defaultTtl']} label="默认 TTL（秒）" rules={[{ required: true }]}>
            <InputNumber min={60} max={86400} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">保存设置</Button>
          </Form.Item>
        </Form>
      </Card>
      <Card title="日志配置">
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name={['log', 'queueMaxSize']} label="队列最大容量" rules={[{ required: true }]}>
            <InputNumber min={100} max={10000} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name={['log', 'flushInterval']} label="刷盘间隔（毫秒）" rules={[{ required: true }]}>
            <InputNumber min={1000} max={60000} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name={['log', 'flushBatchSize']} label="批量刷盘大小" rules={[{ required: true }]}>
            <InputNumber min={100} max={5000} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">保存设置</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
